<template>
  <div>
    <transition name="fade">
      <div :class="[ 'overlay' ]" v-if="open" v-on:click="close"></div>
    </transition>
    <transition name="slide">
      <div class="body loading" v-if="open && isLoading" key="loading">
        <span class="spinner-border spinner-border" role="status"></span>
      </div>
      <div class="body" v-else-if="open && action == 'list'" key="list">
        <div class="title">
          <button class="btn" v-on:click="close">
            <img src="../assets/icons/back.svg" alt="Back" />
          </button>
          Manage Accounts
        </div>
        <div class="current-user">
          <Avatar :name="name" />
          <span class="name">{{ name }}</span>
          <span class="role">{{ role }}</span>
          <div class="buttons">
            <button class="btn" v-on:click="editCurrentUser">Edit</button>
            <button class="btn" v-on:click="logout">Logout</button>
          </div>
        </div>
        <div class="actions">
          <button class="btn btn-red" v-on:click="showAddUser">Add Account</button>
        </div>
        <div v-if="notification" class="alert" v-html="notification"></div>
        <h3>Existing</h3>
        <div class="users">
          <div v-for="(user, i) in users" :key="i" class="user">
            <Avatar :name="user.name" />
            <span class="name">{{ user.name }}</span>
            <button class="btn" v-on:click="showAddUser(user)">Edit</button>
          </div>
        </div>
      </div>
      <div class="body" v-else-if="open && action == 'add'" key="add">
        <div class="title">
          <button class="btn" v-on:click="backToList">
            <img src="../assets/icons/back.svg" alt="Back" />
          </button>
          Add Account
        </div>
        <form class="form" v-on:submit.prevent="saveUser" autocomplete="off">
          <div class="form-group row">
            <label for="fullName" class="col-form-label col-md-3">Name:</label>
            <div class="col-md-9">
              <input type="text" name="fullName" id="fullName" placeholder="Enter full name" class="form-control" v-model="user.name" />
            </div>
          </div>
          <div class="form-group row">
            <label for="email" class="col-form-label col-md-3">Email:</label>
            <div class="col-md-9">
              <input type="email" name="email" id="email" placeholder="Enter email" class="form-control" v-model="user.email" />
            </div>
          </div>
          <div class="form-group row">
            <label for="password" class="col-form-label col-md-3">Password:</label>
            <div class="col-md-9">
              <input type="password" name="password" id="password" :placeholder="user.id ? 'Leave blank to keep password' : 'Enter password'" class="form-control" v-model="user.password" />
            </div>
          </div>
          <div class="form-group row">
            <label for="confirmPassword" class="col-form-label col-md-3">Confirm:</label>
            <div class="col-md-9">
              <input type="password" name="confirmPassword" id="confirmPassword" placeholder="Confirm password" class="form-control" v-model="user.confirmPassword" />
            </div>
          </div>
          <div class="form-group row">
            <label for="type" class="col-form-label col-md-3">Type:</label>
            <div class="col-md-9">
              <select name="type" id="type" class="form-control" v-model="user.account">
                <option value="">Type</option>
                <option v-for="type in userTypes" :value="type.slug" :key="type.slug">{{ type.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group error" v-if="userError">
            <p>{{ userError }}</p>
          </div>
          <div class="form-group action-group">
            <div class="row" v-if="confirmDelete">
              <div class="col delete">
                <div class="title">Are you sure you want to remove this admin?</div>
                <div class="sub-text">Once removed, the admin will not be able to login.</div>
                <div class="row">
                  <div class="col">
                    <button type="button" class="btn btn-red btn-block" v-on:click="remove" :disabled="isLoadingRemove">
                      <span class="spinner-border spinner-border-sm" role="status" v-if="isLoadingRemove"></span>
                      <span v-else>Yes, remove admin.</span>
                    </button>
                  </div>
                  <div class="col">
                    <button type="button" class="btn btn-red-outline btn-block" v-on:click="cancelRemove" :disabled="isLoadingRemove">
                      <span>No, take me back</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div v-if="user.id" class="col">
                <button type="button" class="btn btn-red-outline btn-block" v-on:click="showRemoveConfirm">
                  <span>Remove</span>
                </button>
              </div>
              <div class="col">
                <button type="submit" class="btn btn-red btn-block">
                  <span class="spinner-border spinner-border-sm" role="status" v-if="isLoadingUser"></span>
                  <span v-else-if="user.id">Update</span>
                  <span v-else>Add</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import Avatar from "./Avatar.vue";

export default {
  name: 'ManageUsers',
  components: {
    Avatar,
  },
  props: [ 'open', 'close' ],
  data: function () {
    return {
      isLoading: true,
      isLoadingUser: false,
      isLoadingRemove: false,
      confirmDelete: false,
      notification: "",
      action: 'list',
      users: [],
      user: { account: "" },
      userError: "",
      userTypes: [
        {
          slug: 'admin',
          name: 'Admin',
        },
        {
          slug: 'user',
          name: 'User',
        },
      ],
    };
  },
  computed: {
    ...mapState('session', {
      name: 'name',
      role: 'role',
      id: 'id',
    })
  },
  watch: {
    open: function(newVal) {
      if (newVal === true) {
        this.users = [];
        this.isLoading = true;
        this.action = 'list';
        axios.get('/api/users/admins/read')
          .then((response) => {
            this.isLoading = false;
            if (response.data.users) {
              this.users = response.data.users;
            }
          });
      }
    }
  },
  methods: {
    getEmptyUser: function() {
      return {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        account: "",
      };
    },
    showAddUser: function(user) {
      if (user) {
        this.user = user;
      }
      this.action = 'add';
    },
    editCurrentUser: function() {
      for(let i = 0; i < this.users.length; i++) {
        if (this.users[i].id === this.id) {
          this.showAddUser(this.users[i]);
        }
      }
    },
    backToList: function() {
      this.action = 'list';
      this.user = this.getEmptyUser();
    },
    saveUser: function () {
      this.userError = "";

      const fields = [
        this.user.name,
        this.user.email,
        this.user.account
      ];

      if (!this.user.id) {
        fields.push(this.user.password);
        fields.push(this.user.confirmPassword);
      }

      fields.forEach((field) => {
        if (field == "" || field.trim() == "") {
          this.userError = "Please fill in all fields";
        }
      });

      if (this.user.password && this.user.password.length < 8) {
        this.userError = "Password must be at least 8 characters";
      }

      if (this.user.password != this.user.confirmPassword) {
        this.userError = "Passwords must match";
      }

      if (!this.userError) {
        this.isLoadingUser = true;
        let reqData = new FormData();
        reqData.append('name', this.user.name);
        reqData.append('email', this.user.email);
        reqData.append('account', this.user.account);
        if (this.user.password) {
          reqData.append('password', this.user.password);
        }

        let reqUrl;
        if (this.user.id) {
          reqUrl = `/api/users/${this.user.id}/update`;
        }
        else {
          reqUrl = '/api/users/create';
        }

        axios.post(reqUrl, reqData)
          .then((response) => {
            this.isLoadingUser = false;
            this.notify(this.user.id ? 'update' : 'add', response.data.user)
            this.action = 'list';
            this.user = this.getEmptyUser();
          })
          .catch((error) => {
            this.isLoadingUser = false;
            if (error.response) {
              let errorStr = "";
              if (error.response.data.error) {
                errorStr = error.response.data.error;
              }
              else if (error.response.data.errors) {
                errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
              }
              else {
                errorStr = error.response.data.message;
              }

              this.userError = errorStr;
            }
            else {
              this.userError = "Sorry, something went wrong. Please try again later."
            }
          });
      }
    },
    notify: function(action, user) {
      let message = `<strong>${user.name}</strong> has been `;
      if (action == 'update') {
        message += `updated.`;
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].id == user.id) {
            this.$set(this.users, i, user);
            break;
          }
        }
      }
      else if (action == 'add') {
        message += `added.`;
        this.users.push(user);
      }
      else if (action == 'delete') {
        message += `deleted.`;
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].id == user.id) {
            this.users.splice(i, 1);
            break;
          }
        }
      }

      this.notification = message;
    },
    showRemoveConfirm: function() {
      this.confirmDelete = true;
    },
    remove: function() {
      this.isLoadingRemove = true;
      axios.get(`/api/users/${this.user.id}/delete`)
        .then(() => {
          this.isLoadingRemove = false;
          this.notify('delete', this.user);
          this.confirmDelete = false;
          this.action = 'list';
          this.user = this.getEmptyUser();
        })
        .catch((error) => {
          this.isLoadingRemove = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            }
            else if (error.response.data.errors) {
              errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
            }
            else {
              errorStr = error.response.data.message;
            }

            this.userError = errorStr;
          }
          else {
            this.userError = "Sorry, something went wrong. Please try again later."
          }
        });
    },
    cancelRemove: function() {
      this.confirmDelete = false;
    },
    logout: function() {
      this.$store.dispatch('session/logout');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.overlay {
  background: rgba(black, 0.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

div.body {
  position: fixed;
  z-index: 11;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background: white;
  width: 550px;
  overflow-y: auto;
  padding: 60px 27px 0;

  &.loading {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div.title {
    color: #4A4A4A;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.2;
    position: relative;
    padding-left: 1rem;
    margin: 0 0 57px;

    button {
      position: absolute;
      right: calc(100% - 1rem);
      padding: 0 10px;
    }
  }
}

div.current-user {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span.name {
    color: #4A4A4A;
    line-height: calc(18 / 16);
    margin: 0 13px;
  }

  span.role {
    color: #222222;
    opacity: 0.56;
    line-height: calc(18 / 16);
    font-size: 0.75rem;
    text-transform: capitalize; 
    position: relative;
    top: 2px;
  }

  div.buttons {
    margin-left: auto;
  }

  button.btn {
    padding: 0;
    font-size: 0.875rem;
    color: var(--accentColor);
    margin-right: 1rem;

    &:last-child {
      margin-right: 0;
    }
  }
}

div.actions {
  margin: 2.5rem 0 3.75rem;
  border-color: #EBEBEB;
  border-style: solid;
  border-width: 1px 0;
  padding: 2rem 0;
}

h3 {
  font-size: 1.25rem;
  font-weight: 500;
  color: #4A4A4A;
  line-height: calc(24 / 20);
  margin: 0 0 1.5rem;
}

div.users {
  margin-bottom: 3rem;
}

div.user {
  background: #FFFFFF;
  border: 1px solid #ECECEC;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  margin: 0 0 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  span.name {
    color: #4A4A4A;
    line-height: calc(18 / 16);
    margin: 0 13px;
  }

  button.btn {
    color: var(--accentColor);
    padding: 0;
    margin-left: auto;
    font-size: 0.875rem;
  }
}

form.form {
  padding: 0 30px;
}

div.form-group {
  &.action-group {
    margin-top: 2rem;
  }
}

div.delete {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  div.title {
    font-weight: 500;
    text-align: center;
    font-size: 1.25rem;
    line-height: calc(24 / 20);
    margin: 0 auto 24px;
  }

  div.sub-text {
    font-size: 0.875rem;
    text-align: center;
    margin: 0 auto 24px;
  }

  div.row {
    width: 100%;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform .25s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(550px);
}
</style>
